import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://octosapien.github.io  '
      className='link footer__link'
    >
      Created with 🧠 By Sahil Singh
    </a>
  </footer>
)

export default Footer
